<!-- <p>curso-inscrito-detalle works!</p> -->
<!-- <p-toast styleClass="custom-toast" ></p-toast> -->
<div class="card border-primary ui-g" style="display: block; padding: .5em;">

    <p-tabMenu [model]="items" [activeItem]="activeItem">
    </p-tabMenu>

    <div class="ui-g-12" [ngSwitch]="activeItem.label" style="background-color:white">
        <div *ngSwitchCase="items[0].label">
            <div class="ui-g ui-fluid">

                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Tema: </label>
                    <label> {{inscritoDetalle.tema}}</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">tipo: </label>
                    <label> {{getDesTipo(inscritoDetalle.tipo)}}</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Puntaje total: </label>

                    <label> {{inscritoDetalle.puntajeTotal}}</label>

                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Capacidad / Disponibles: </label>
                    <label> {{inscritoDetalle.capacidad}}/{{inscritoDetalle.disponibles}}</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Fecha programada: </label>
                    <label> {{formatoFecha(inscritoDetalle.fechIni)}}</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Fecha de Finalización: </label>
                    <label> {{formatoFecha(inscritoDetalle.fechaFinal)}}</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Duración: </label>
                    <label> {{inscritoDetalle.duracion}} hora(s)</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Vigencia: </label>
                    <label> {{inscritoDetalle.vigencia}} {{getVigencia(inscritoDetalle.codVigenciaCapacita)}}</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Empresa Capacitadora: </label>
                    <label> {{getEmpresa(inscritoDetalle.codEmpresaCap)}}</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Expositor (es): </label>
                    <!-- <label > {{cursodetalle.expoName}}</label> -->
                    <li *ngFor="let expositor of inscritoDetalle.expositores" style="text-align: left">
                        <a> {{expositor.nombre}} </a>
                    </li>
                </div>

                <div class="ui-g-12 ui-md-12">
                    <label>Material del curso: </label>

                    <p-table class="ui-g-12" [value]="materialCurso" [responsive]="true">
                        <ng-template pTemplate="header">
                            <tr>

                                <th style="width:50%">Nombre</th>
                                <th style="width:10%">Tamaño</th>
                                <th style="width:20%">Descripción</th>
                                <th style="width:10%">Revisado</th>
                                <th style="width:10%">Acción</th>

                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-Material>
                            <tr>
                                <td><span class="ui-column-title">Nombre</span>{{Material.nombre}} </td>
                                <td><span class="ui-column-title">Tamaño</span> {{readableBytes(Material.size)}}</td>
                                <td><span class="ui-column-title">Descripción</span>{{Material.descripcion}} </td>
                                <td><span class="ui-column-title">Revisado</span> {{getRevisado(Material.revisado)}}
                                </td>
                                <td>
                                    <button type="button" pButton icon="pi pi-download"
                                        (click)="descargarMaterial(Material)" class="ui-button-info"></button>
                                </td>

                                <!-- <td>{{Expositor.estado}}</td> -->
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

                <div class="ui-g-12 ui-md-12" [hidden]="verEnlace">
                    <label [style]="{'width':'100%'}">Enlace del curso: </label>
                    <!-- <label> https://zoom.us/?utm_source=web&utm_medium=blog&utm_campaign=post </label> -->

                    <li style="text-align: left">
                        <a href="{{inscritoDetalle.enlace}}" target="_blank"> {{inscritoDetalle.enlace}} </a>
                    </li>
                </div>




            </div>
        </div>

        <div *ngSwitchCase="items[1].label">
            <div class="ui-g ui-fluid">
                <div class="ui-g-12 ui-md-12" [hidden]="verPreguntas">
                    <h2> Evaluación en línea </h2>
                    <ul>
                        <li>
                            <b> Puntaje Total: </b> {{inscritoDetalle.puntajeTotal}}
                        </li>
                        <li>
                            <b> Total de preguntas: </b> {{totalPreguntas}}

                        </li>
                    </ul>

                    <h2> Instrucciones </h2>
                    <ul>
                        <li>
                            Para realizar el examen, el usuario debera haber revisado el material del curso
                        </li>
                    </ul>
                </div>
                <div class="ui-g-12 ui-md-12" [hidden]="verPreguntas">
                    <div class="ui-g-12 ui-md-4">
                    </div>
                    <div class="ui-g-12 ui-md-4">
                        <button type="button" pButton (click)="empezarExamen()" label="Empezar examen"
                            class="ui-button-info" style="width: 100%;" [disabled]="btnPreg"></button>
                    </div>
                    <div class="ui-g-12 ui-md-4">
                    </div>
                </div>

                <div class="ui-g-12 ui-md-12" [hidden]="!verPreguntas">
                    <!-- <div id="dest12">

                    </div> -->





                    <p-panel [style]="{width: '100%'}" styleClass="p-card-shadow">

                        <p-header>


                            <div *ngIf="selPregunta.tipo === '1'|| selPregunta.tipo === '2'">
                                <h3> <b> Pregunta {{countNPreg+1}}/{{totalPreguntas}} ({{selPregunta.puntaje}} puntos)&nbsp;
                                    </b>&nbsp;
                                </h3>
                            </div>
        
                            <div *ngIf="selPregunta.tipo === '3'">
                                <h3> <b> Pregunta {{countNPreg+1}}/{{totalPreguntas}} </b>&nbsp;
                                    ({{selPregunta.puntaje}} puntos)
                                </h3>
                            </div>
        
                            <div  [innerHTML]="selPregunta.descripcion" style="padding: 0;"></div>




                            <div *ngIf="selPregunta.tipo === '1'|| selPregunta.tipo === '2'">
                                <h4> &nbsp;(Seleccione {{selPregunta.countRespuestas}} respuesta(s)) &nbsp;
                                </h4>
                            </div>

                        </p-header>



                        <div class="ui-g ui-fluid">
                            <div class="ui-g-12 ui-md-12 ui-lg-12">

                                <ng-container [ngSwitch]="selPregunta.tipo">
                                    <ng-container *ngSwitchCase="'1'">

                                        <div class="ui-g-12 ui-md-12 ui-lg-12"
                                            *ngFor="let alternativa of selPregunta.alternativas">
                                            <p-radioButton value="{{alternativa.codAlternativa}}"
                                                label="{{alternativa.descripcion}}" [(ngModel)]="selectedValue"
                                                (ngModelChange)="simpleChange()"></p-radioButton>
                                        </div>

                                    </ng-container>
                                    <ng-container *ngSwitchCase="'2'">
                                        <div class="ui-g-12 ui-md-12 ui-lg-12"
                                            *ngFor="let alternativa of selPregunta.alternativas">
                                            <p-checkbox name="groupname" value="{{alternativa.codAlternativa}}"
                                                label="{{alternativa.descripcion}}" [(ngModel)]="selMultiValue"
                                                (ngModelChange)="multiChange()"></p-checkbox>
                                        </div>



                                    </ng-container>
                                    <ng-container *ngSwitchCase="'3'">
                                        <div *ngIf="selPregunta.countRespuestas === 0"
                                            class="ui-g-12 ui-md-12 ui-lg-12">
                                            <!-- <input class="ui-inputtext" type="text" pInputText placeholder="Respuesta"
                                                [(ngModel)]="respText" (ngModelChange)="completaChange()"> -->

                                            <textarea class="ui-inputtext" type="text" rows="4" cols="30" pInputTextarea
                                                autoResize="autoResize" placeholder="Respuesta" [(ngModel)]="respText"
                                                (ngModelChange)="completaChange()"></textarea>



                                        </div>
                                        <div *ngIf="selPregunta.countRespuestas !== 0"
                                            class="ui-g-12 ui-md-12 ui-lg-12">
                                            <input class="ui-inputtext" type="text" pInputText placeholder="Respuesta"
                                                [(ngModel)]="respText" (ngModelChange)="completaChange()">

                                            <!-- <textarea class="ui-inputtext" type="text" rows="4" cols="30" pInputTextarea
                                                autoResize="autoResize" placeholder="Respuesta"
                                                [(ngModel)]="respText" (ngModelChange)="completaChange()" ></textarea> -->



                                        </div>


                                    </ng-container>



                                </ng-container>





                            </div>

                        </div>

                        <p-footer>

                            <div class="ui-g ui-fluid">
                                <div class="ui-g-12 ui-md-2">
                                    <button type="button" pButton icon="pi pi-angle-left" (click)="antPregunta()"
                                        label="Anterior" class="ui-button-info" style="width: 100%;"
                                        [disabled]="btnPrevSt"></button>
                                </div>
                                <div class="ui-g-12 ui-md-8">
                                    <button type="button" pButton (click)="FinalizarExamen()" label="Finalizar"
                                        class="ui-button-info" style="width: 100%;" [disabled]="btnFinSt"></button>
                                </div>
                                <div class="ui-g-12 ui-md-2">
                                    <button type="button" pButton icon="pi pi-angle-right" (click)="SigPregunta()"
                                        label="Siguiente" class="ui-button-info" style="width: 100%;"
                                        [disabled]="btnNextSt"></button>
                                </div>
                            </div>
                        </p-footer>
                    </p-panel>

                </div>



            </div>
        </div>



    </div>

</div>


<!--     popUp pdf view curso -->
<p-dialog header="Detalle del curso" *ngIf="verVisor" [(visible)]="verVisor" [style]="{width: '100%'}" [modal]="true" [draggable]="true"
    [resizable]="true" [modal]="true" [responsive]="true" [baseZIndex]="10000" [maximizable]="true">

    <p-header>
    </p-header>

    <ng-container>
        <app-visor-pdf [src]="urlPdf" (estadopdf)="getEstadoPdf($event)"></app-visor-pdf>
    </ng-container>
</p-dialog>


<!--     popUp video view curso -->
<p-dialog header="Video" [(visible)]="verVisorVideo" [style]="{width: '75%'}" [modal]="true" [draggable]="false"
    [resizable]="false" [modal]="true" [responsive]="true" [baseZIndex]="10000">

    <p-header>
    </p-header>


    <ng-container>

        <app-visor-video [videoSource]="urlVideo" (estadoVideo)="getEstadoVideo($event)"></app-visor-video>

    </ng-container>
</p-dialog>







<!--     popUp seleccionar curso -->
<p-dialog header="Resultado de Evaluación" [(visible)]="verResultado"
    [style]="{  width: '40%', minHeight: '150px', maxHeight: '80vh'}"
    [contentStyle]="{'overflow-x': 'hidden', 'max-height': '60vh', 'min-height': '250px'}" [minY]="70" [modal]="true"
    [draggable]="true" [resizable]="true" dismissableMask="true" [responsive]="true" [baseZIndex]="1000" (onHide)= "AceptarResultado()">
    <p-header>
    </p-header>

    <ng-container>

        <div class="ui-g ui-fluid">
            <div class="ui-g-12 ui-md-12" [hidden]="hidenNota">
                <label [style]="{'width':'40%'}">Nota: </label>
                <label> {{resultado.nota}}</label>
            </div>

            <div class="ui-g-12 ui-md-12" [hidden]="!hidenNota">
                <label [style]="{'width':'40%'}">Nota Acumulada: </label>
                <label> {{resultado.nota}}</label>
            </div>

            <div class="ui-g-12 ui-md-12" [hidden]="!hidenNota">
                <label [style]="{'width':'40%'}">Nota pendiente: </label>
                <label> {{notaPendiente}}</label>
            </div>

            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">Estado de Evaluación: </label>
                <label> {{resultado.estadoEvaluacion}}</label>
            </div>
            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">Porcentaje de aprobación: </label>
                <label> {{resultado.porcentajeEval}}</label>
            </div>
            <div class="ui-g-12 ui-md-12">
                <label [style]="{'width':'40%'}">Puntaje Total: </label>
                <label> {{resultado.puntajeTotal}}</label>
            </div>


        </div>

    </ng-container>

    <p-footer>

        <div class="ui-g ui-fluid">
            <div class="ui-g-12 ui-md-12" [hidden]="!hidenNota">
                <button type="button" pButton (click)="AceptarResultado()" label="No Aprobo el Curso" class="ui-button-success"
                    style="width: 100%;"></button>
            </div>
            <div class="ui-g-12 ui-md-12" [hidden]="hidenNota">
                <button type="button" pButton (click)="EnviarCertificado()" label="Ver Certificado"
                    class="ui-button-success" style="width: 100%;"></button>
            </div>

        </div>
    </p-footer>
</p-dialog>